/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { LineItem } from "./LineItem";
import {
  LineItemFromJSON,
  LineItemFromJSONTyped,
  LineItemToJSON,
  LineItemToJSONTyped,
} from "./LineItem";
import type { Location } from "./Location";
import {
  LocationFromJSON,
  LocationFromJSONTyped,
  LocationToJSON,
  LocationToJSONTyped,
} from "./Location";
import type { QuoteTestScenarioMetadata } from "./QuoteTestScenarioMetadata";
import {
  QuoteTestScenarioMetadataFromJSON,
  QuoteTestScenarioMetadataFromJSONTyped,
  QuoteTestScenarioMetadataToJSON,
  QuoteTestScenarioMetadataToJSONTyped,
} from "./QuoteTestScenarioMetadata";

/**
 *
 * @export
 * @interface PostQuoteTestPermutationGroupBody
 */
export interface PostQuoteTestPermutationGroupBody {
  /**
   *
   * @type {string}
   * @memberof PostQuoteTestPermutationGroupBody
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof PostQuoteTestPermutationGroupBody
   */
  description: string;
  /**
   *
   * @type {Array<LineItem>}
   * @memberof PostQuoteTestPermutationGroupBody
   */
  lineItems: Array<LineItem>;
  /**
   *
   * @type {Location}
   * @memberof PostQuoteTestPermutationGroupBody
   */
  pickupLocation: Location;
  /**
   *
   * @type {Location}
   * @memberof PostQuoteTestPermutationGroupBody
   */
  deliveryLocation: Location;
  /**
   *
   * @type {QuoteTestScenarioMetadata}
   * @memberof PostQuoteTestPermutationGroupBody
   */
  metadata?: QuoteTestScenarioMetadata | null;
  /**
   *
   * @type {string}
   * @memberof PostQuoteTestPermutationGroupBody
   */
  carrierIdentifier: string;
  /**
   *
   * @type {string}
   * @memberof PostQuoteTestPermutationGroupBody
   */
  serviceIdentifier: string;
}

/**
 * Check if a given object implements the PostQuoteTestPermutationGroupBody interface.
 */
export function instanceOfPostQuoteTestPermutationGroupBody(
  value: object,
): value is PostQuoteTestPermutationGroupBody {
  if (!("title" in value) || value["title"] === undefined) return false;
  if (!("description" in value) || value["description"] === undefined)
    return false;
  if (!("lineItems" in value) || value["lineItems"] === undefined) return false;
  if (!("pickupLocation" in value) || value["pickupLocation"] === undefined)
    return false;
  if (!("deliveryLocation" in value) || value["deliveryLocation"] === undefined)
    return false;
  if (
    !("carrierIdentifier" in value) ||
    value["carrierIdentifier"] === undefined
  )
    return false;
  if (
    !("serviceIdentifier" in value) ||
    value["serviceIdentifier"] === undefined
  )
    return false;
  return true;
}

export function PostQuoteTestPermutationGroupBodyFromJSON(
  json: any,
): PostQuoteTestPermutationGroupBody {
  return PostQuoteTestPermutationGroupBodyFromJSONTyped(json, false);
}

export function PostQuoteTestPermutationGroupBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PostQuoteTestPermutationGroupBody {
  if (json == null) {
    return json;
  }
  return {
    title: json["title"],
    description: json["description"],
    lineItems: (json["lineItems"] as Array<any>).map(LineItemFromJSON),
    pickupLocation: LocationFromJSON(json["pickupLocation"]),
    deliveryLocation: LocationFromJSON(json["deliveryLocation"]),
    metadata:
      json["metadata"] == null
        ? undefined
        : QuoteTestScenarioMetadataFromJSON(json["metadata"]),
    carrierIdentifier: json["carrierIdentifier"],
    serviceIdentifier: json["serviceIdentifier"],
  };
}

export function PostQuoteTestPermutationGroupBodyToJSON(
  json: any,
): PostQuoteTestPermutationGroupBody {
  return PostQuoteTestPermutationGroupBodyToJSONTyped(json, false);
}

export function PostQuoteTestPermutationGroupBodyToJSONTyped(
  value?: PostQuoteTestPermutationGroupBody | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    title: value["title"],
    description: value["description"],
    lineItems: (value["lineItems"] as Array<any>).map(LineItemToJSON),
    pickupLocation: LocationToJSON(value["pickupLocation"]),
    deliveryLocation: LocationToJSON(value["deliveryLocation"]),
    metadata: QuoteTestScenarioMetadataToJSON(value["metadata"]),
    carrierIdentifier: value["carrierIdentifier"],
    serviceIdentifier: value["serviceIdentifier"],
  };
}
